import { SaleDTO } from './SaleDTO'
import { OrderDTO } from './OrderDTO'
import { AddressDTO } from './AddressDTO'
import { BookingDocketDTO } from './BookingDocketDTO'
import { BookingStatusTypeDTO } from './BookingStatusTypeDTO'
import { CancellationReasonDTO } from './CancellationReasonDTO'

export class BookingDetailsDTO {
    constructor(
        public bookingId: string,
        public currencyCode: string | null,
        public venueId: string,
        public venueName: string,
        public venueAddress: AddressDTO,
        public venueDiningInformation: string | null,
        public venueEmailAddress: string | null,
        public venuePhoneNumber: string | null,
        public bookingName: string,
        public bookingEmailAddress: string | null,
        public partySize: number,
        public durationMinutes: number,
        public dateTime: string,
        public statusType: BookingStatusTypeDTO,
        public cancellationChargeAmount: number | null,
        public cancellationChargeCutOffTime: string | null,
        public areaId: string,
        public areaName: string | null,
        public reasonId: string | null,
        public reasonName: string | null,
        public reasonDiningInformation: string | null,
        public reasonIsLinkExclusive: boolean,
        public eventId: string | null,
        public eventName: string | null,
        public eventImageUrl: string | null,
        public depositAmount: number | null,
        public depositAmountPaid: number | null,
        public depositAmountOutstanding: number | null,
        public depositCurrencyCode: string | null,
        public depositDatePaid: string | null,
        public depositDateRefunded: string | null,
        public depositRefundCutOffTime: string | null,
        public depositRefundPolicy: string | null,
        public requiresWheelchairAccess: boolean,
        public requiresDogFriendly: boolean,
        public requiresPramAccessible: boolean,
        public requiresHighchairFriendly: boolean,
        public modifyBookingPath: string | null,
        public pendingPaymentExpiryDateTime: string | null,
        public docket: BookingDocketDTO | null,
        public cancellationReasons: CancellationReasonDTO[],
        public order: OrderDTO | null = null,
        public additionalBookings: BookingDetailsDTO[] = [],
        public sale: SaleDTO | null = null,
        public orderRefundableLineIds: string[] = [],
        public cancellationAmountCharged: number = 0,
        public cancellationChargeAutomatically: boolean = true,
        public depositAmountRefundable: number | null = null
    ) { }
}
